import { animate, state, style, transition, trigger } from '@angular/animations'

export const blueAndGrayAnimation = trigger('blueAndGrayAnimation', [
  state('blue', style({ fill: '#4285eb' })),
  state('gray', style({ fill: '#C6C6C6' })),
  transition('* => gray', [animate('1s')]),
  transition('* => blue', [animate('1s')]),
])
